import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  create(data) {
    // The API uses strong parameters and requires the payload to be nested
    // under `notification_subscription`. Sending the attributes at the root
    // makes Rails reject the request before a browser subscription is saved.
    return super.create({ notification_subscription: data });
  }

  destroyBrowserPush(endpoint) {
    return window.axios.delete(this.url, { params: { endpoint } });
  }
}

export default new NotificationSubscriptions();
